var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v(_vm._s(_vm.$t('footer'))+" "),_c('img',{attrs:{"src":require("@/assets/images/fot.png")}})]),_vm._v(" "),_c('div',[_c('p',[_vm._v(_vm._s(_vm.$t('jishuzhichi')))]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.$t('map')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b51e0b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/foot.vue
// module id = null
// module chunks = 